import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListadoGruposComponent } from '../../standalone/grupos/listado-grupos/listado-grupos.component';
import { ListadoUbicacionesComponent } from '../../standalone/ubicaciones/listado-ubicaciones/listado-ubicaciones.component';
import { CrearEditarUbicacionComponent } from '../../standalone/ubicaciones/crear-editar-ubicacion/crear-editar-ubicacion.component';
import { ListadoVehiculosComponent } from './vehiculos/listado-vehiculos/listado-vehiculos.component';
import { DetallesVehiculoComponent } from './vehiculos/detalles-vehiculo/detalles-vehiculo.component';
import { CrearEditarVehiculoComponent } from './crear-editar-vehiculo/crear-editar-vehiculo.component';
import { ListadoChoferesComponent } from '../../standalone/choferes/listado-choferes/listado-choferes.component';
import { ListadoEnviosVehiculosComponent } from './envios-movil/listado/listado.component';
import { ContenedorMapaComponent } from './contenedor-mapa/contenedor-mapa.component';
import { ListadoRecorridosVehiculosComponent } from './recorridos/listado-recorridos/listado-recorridos.component';
import { CrearEditarRecorridoVehiculosComponent } from './recorridos/crear-editar-recorrido/crear-editar-recorrido.component';
import { PlanificadorRutaVehiculosComponent } from './recorridos/planificador-ruta/planificador-ruta.component';
import { ListadoRecorridosDinamicosVehiculosComponent } from './recorridos-dinamicos/listado-recorridos-dinamicos/listado-recorridos-dinamicos.component';
import { ListadoProveedoresComponent } from '../../standalone/proveedores/listado-proveedores/listado-proveedores';
import { ListadoServiciosComponent } from '../../standalone/servicios/listado-servicios/listado-servicios.component';
import { CrearEditarServicioComponent } from '../../standalone/servicios/crear-editar-servicio/crear-editar-servicio.component';
import { ListadoRecordatoriosComponent } from '../../standalone/recordatorios/listado-recordatorios/listado-recordatorios.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { DashboardVehiculosComponent } from './dashboard/dashboard-vehiculos.component';

const routes: Routes = [
  { path: '', redirectTo: 'mapa', pathMatch: 'full' },
  {
    path: 'dashboard',
    title: 'Dashboard de vehículos',
    component: DashboardVehiculosComponent,
    canActivate: [],
  },
  {
    path: 'vehiculos',
    title: 'Vehículos',
    component: ListadoVehiculosComponent,
    canActivate: [],
  },
  // Listado del menú de Servicio Técnico: el mismo, con la función fija y
  // solo para ver.
  {
    path: 'servicio-tecnico',
    title: 'Vehículos de servicio técnico',
    component: ListadoVehiculosComponent,
    canActivate: [],
    data: { funcion: 'Servicio Técnico', soloLectura: true },
  },
  // Vehiculos
  {
    path: 'vehiculos/crear',
    title: 'Nuevo vehículo',
    component: CrearEditarVehiculoComponent,
    canActivate: [],
  },
  {
    path: 'vehiculos/editar',
    title: 'Editar vehículo',
    component: CrearEditarVehiculoComponent,
    canActivate: [],
  },
  {
    path: 'vehiculos/detalles/:id',
    title: 'Vehículo',
    component: DetallesVehiculoComponent,
    canActivate: [],
  },

  // Mapa
  {
    path: 'mapa',
    title: 'Mapa de vehículos',
    component: ContenedorMapaComponent,
    canActivate: [],
  },

  // Ubicaciones
  {
    path: 'ubicaciones/:categoria',
    title: 'Ubicaciones y zonas',
    component: ListadoUbicacionesComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/crear',
    title: 'Nueva ubicación',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/editar/:id',
    title: 'Editar ubicación',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  // Agrupaciones
  {
    path: 'grupos/:categoria',
    title: 'Flota',
    component: ListadoGruposComponent,
    canActivate: [],
  },
  // Choferes
  {
    path: 'conductores',
    title: 'Conductores',
    component: ListadoChoferesComponent, //El listado de choferes es el mismo para choferes y para conductoresz

    canActivate: [],
  },
  // Envíos vehículos
  {
    path: 'enviosVehiculos',
    title: 'Envíos de vehículos',
    component: ListadoEnviosVehiculosComponent,

    canActivate: [],
  },

  // Recorridos
  {
    path: 'recorridos',
    title: 'Recorridos',
    component: ListadoRecorridosVehiculosComponent,
    canActivate: [],
  },
  {
    path: 'recorridos/crear',
    title: 'Nuevo recorrido',
    component: CrearEditarRecorridoVehiculosComponent,
    canActivate: [],
  },
  {
    path: 'recorridos/editar',
    title: 'Editar recorrido',
    component: CrearEditarRecorridoVehiculosComponent,
    canActivate: [],
  },
  // Recorridos dinámicos (por puntos)
  {
    path: 'recorridos-dinamicos',
    title: 'Recorridos dinámicos',
    component: ListadoRecorridosDinamicosVehiculosComponent,
    canActivate: [],
  },
  {
    path: 'recorridos-dinamicos/planificador',
    title: 'Planificador de ruta',
    component: PlanificadorRutaVehiculosComponent,
    canActivate: [],
  },

  // Servicios
  {
    path: 'servicios/:categoria',
    title: 'Proveedores',
    component: ListadoServiciosComponent,
    canActivate: [],
  },
  {
    path: 'servicios/:categoria/crear',
    title: 'Nuevo proveedor',
    component: CrearEditarServicioComponent,
    canActivate: [],
  },
  {
    path: 'servicios/:categoria/editar/:id',
    title: 'Editar proveedor',
    component: CrearEditarServicioComponent,
    canActivate: [],
  },

  // Proveedores
  {
    path: 'proveedores/:categoria',
    title: 'Proveedores',
    component: ListadoProveedoresComponent,
    canActivate: [],
  },

  // Recordatorios
  {
    path: 'recordatorios/:categoria',
    title: 'Recordatorios',
    component: ListadoRecordatoriosComponent,
    canActivate: [],
  },
  {
    path: 'recordatorios/:categoria/crear',
    title: 'Recordatorios',
    component: ListadoRecordatoriosComponent,
    canActivate: [],
  },
  {
    path: 'recordatorios/:categoria/editar/:id',
    title: 'Recordatorios',
    component: ListadoRecordatoriosComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehiculosRoutingModule {}
